"use client";
import { usePathname, useSearchParams } from "next/navigation";
import { useRouter } from "next13-progressbar";
import { Pagination } from "@nextui-org/pagination";

const ResultPagination = ({ currentPage, totalPages }) => {
  const router = useRouter();

  const handleOnChange = (pathname, q, o, p, f) => {
    let url = `${pathname}?`;

    // Agregar cada parámetro si no es null
    if (q != null) {
      url += `q=${q}&`;
    }
    if (o != null) {
      url += `o=${o}&`;
    }
    if (p != null) {
      url += `p=${p}&`;
    }

    // Verificar si el primer elemento de f no es null y agregar todos los filtros
    if (f && f[0] != null) {
      const filtersString = f.map((filter) => `f=${filter}`).join("&");
      url += filtersString;
    } else {
      // Eliminar el último '&' si no hay filtros
      url = url.slice(0, -1);
    }
    router.push(url);
  };

  const pathname = usePathname();

  const params = useSearchParams();
  const q = params.get("q");
  const o = params.get("o");
  let f = params.getAll("f");
  f = Array.isArray(f) ? f : f !== undefined ? [f] : [];

  return (
    <div className="flex justify-center my-10">
      {totalPages !== 0 && (
        <Pagination
          total={totalPages}
          page={currentPage}
          onChange={(p) => handleOnChange(pathname, q, o, p, f)}
        />
      )}
    </div>
  );
};

export default ResultPagination;
